var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CrmKanbanUi',{attrs:{"stages":_vm.columns,"leads":_vm.viewLeads},on:{"moveLead":_vm.onLeadMove,"removeLead":_vm.removeLead,"openLead":function($event){return _vm.$emit('openLead', $event.id)}}})}
var staticRenderFns = []

export { render, staticRenderFns }